import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Typography,
  DialogActions,
  DialogContentText,
  Stack,
  Box,
  Alert,
  Snackbar,
  Link,
} from "@mui/material";
import sendVerification from "../api/user/sendVerification";
import register from "../api/user/register";
import sendPasswordReset from "../api/user/sendPasswordReset";
import login from "../api/user/login";
import api from "../api/api";
import { AuthContext } from "../context/AuthContext";
import { USERCONTRACT } from "../data/USERCONTRACT";
import ResetPasswordDialog from "./ResetPasswordDialog";
const LoginDialogs = ({ openLogin, handleLoginClose, setToken }) => {
  const [openRegister, setOpenRegister] = useState(false);
  const [openVerification, setOpenVerification] = useState(false);
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const [openUserContract, setOpenUserContract] = useState(false);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const handleForgotPasswordOpen = () => {
    setPhone("");
    setError("");
    setOpenForgotPassword(true);
  };
  const handleForgotPasswordClose = () => {
    setOpenForgotPassword(false);
  };
  const handleRegisterOpen = () => {
    setOpenRegister(true);
    setPassword("");
    setConfirmPassword("");
  };
  const handleRegisterClose = () => {
    setOpenRegister(false);
  };

  const handleVerificationOpen = () => setOpenVerification(true);
  const handleVerificationClose = () => {
    setOpenVerification(false);
    setVerificationCode("");
  };

  // Declare state variables for each field
  /* Login */

  const userContext = useContext(AuthContext);
  const [loginData, setLoginData] = useState({
    phone: "",
    password: "",
  });

  /* Register */
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordNotMatch, setPasswordNotMatch] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  /* Verification */
  const [verificationCode, setVerificationCode] = useState("");
  const [snakeOpen, setSnakeOpen] = useState(false);
  const [snakeMsg, setSnakeMsg] = useState("");

  /* Global */
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(null);
  const [alertHidden, setAlertHidden] = useState(true);

  useEffect(() => {
    if (error === "" || error === null || isNaN(error)) {
      setAlertHidden(true);
    } else {
      console.log(error);
      setAlertHidden(false);
    }
  }, [error]);
  useEffect(() => {
    if (openLogin) {
      setError("");
      setLoginData({
        phone: "",
        password: "",
      });
    }
  }, [openLogin]);
  useEffect(() => {
    if (password === confirmPassword) {
      setPasswordNotMatch(false);
    } else {
      setPasswordNotMatch(true);
    }
  }, [password, confirmPassword]);
  useEffect(() => {
    if (phone.length !== 10 && phone !== "") {
      setPhoneError(true);
    } else {
      setPhoneError(false);
    }
  }, [phone]);

  const handleSendResetPasswordClick = async () => {
    if (phone !== "") {
      setLoading(true);
      try {
        const responseData = await sendPasswordReset(phone);

        if (responseData.code === "000") {
          handleForgotPasswordClose();
          setOpenResetPassword(true);
          setSnakeMsg("發送成功，請確認您的簡訊。");
        } else {
          setError(responseData.message);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSendVerificationButtonClick = async () => {
    setError("");
    if (
      phone !== "" &&
      (password !== "") & (confirmPassword !== "") &&
      !phoneError &&
      !passwordNotMatch
    ) {
      setLoading(true);
      try {
        const responseData = await sendVerification(phone);

        if (responseData.code === "000") {
          handleVerificationOpen();
          handleRegisterClose();
        } else {
          setError(responseData.message);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleRegisterButtonClick = async () => {
    if (verificationCode.length === 6) {
      setLoading(true);
      try {
        const responseData = await register(
          name,
          phone,
          password,
          verificationCode
        );
        if (responseData.code === "000") {
          handleVerificationClose();
          setSnakeMsg("註冊完成，請進行登入。");
          setSnakeOpen(true);
        } else {
          setError(responseData.message);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    } else {
      setError("驗證碼長度不足");
    }
  };
  const handleLoginButtonClick = async () => {
    if (loginData.phone.length === 10) {
      setLoading(true);
      try {
        const responseData = await login(loginData.phone, loginData.password);

        if (responseData.code === "000") {
          handleLoginClose();

          localStorage.setItem("token", responseData.token);
          api.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${responseData.token}`;
          userContext.setUser(responseData.user);
          setSnakeMsg("登入成功。");
          setToken(responseData.token);
          setSnakeOpen(true);
        } else {
          setError(responseData.message);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    } else {
      setError("手機號碼長度錯誤");
    }
  };
  return (
    <div>
      <Dialog open={openLogin} onClose={handleLoginClose}>
        <DialogTitle sx={{ fontWeight: "bold" }}>
          登入
          <Button
            aria-label="close"
            onClick={handleLoginClose}
            sx={{
              position: "absolute",
              right: 3,
              top: 14,
              color: (theme) => theme.palette.grey[600],
            }}
          >
            x
          </Button>
        </DialogTitle>
        <DialogContent>
          <TextField
            color="secondary"
            autoFocus
            variant="outlined"
            margin="dense"
            id="username"
            label="手機號碼"
            value={loginData.phone}
            onChange={(e) =>
              setLoginData((prevState) => ({
                ...prevState,
                phone: e.target.value,
              }))
            }
            type="text"
            fullWidth
          />
          <TextField
            color="secondary"
            margin="dense"
            id="password"
            label="密碼"
            value={loginData.password}
            onChange={(e) =>
              setLoginData((prevState) => ({
                ...prevState,
                password: e.target.value,
              }))
            }
            type="password"
            fullWidth
          />

          {error !== "" ? (
            <Alert icon={false} severity="warning">
              {error}
            </Alert>
          ) : null}

          <Link sx={{ color: "cadetblue" }} onClick={handleForgotPasswordOpen}>
            忘記密碼
          </Link>
        </DialogContent>

        <DialogActions>
          <Button
            color="secondary"
            sx={{ color: "#004B97", border: "1px solid #ACD6FF" }}
            onClick={() => {
              setError("");
              setOpenUserContract(true);
              handleLoginClose();
            }}
          >
            建立會員
          </Button>
          <Box style={{ flexGrow: 2 }}> </Box>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            disabled={loading}
            onClick={handleLoginButtonClick}
          >
            {loading ? "登入中..." : "登入"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openUserContract}
        onClose={() => setOpenUserContract(false)}
      >
        <DialogTitle>會員服務條款</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              variant="body1"
              component="pre"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {USERCONTRACT}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{ border: "1px solid #555555" }}
            onClick={() => setOpenUserContract(false)}
            color="primary"
          >
            不同意
          </Button>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            onClick={() => {
              setOpenUserContract(false);
              handleRegisterOpen();
            }}
            color="primary"
            autoFocus
          >
            同意
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openRegister} onClose={handleRegisterClose}>
        <DialogTitle sx={{ fontWeight: "bold" }}>註冊</DialogTitle>
        <DialogContent>
          <TextField
            color="secondary"
            autoFocus
            margin="dense"
            id="phone"
            label="手機號碼"
            type="number"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            error={phoneError} // Here we set the error state of TextField
            helperText={phoneError ? "手機號碼格式錯誤" : ""} // Here we set the helper text when there is an error
            fullWidth
          />
          <Box>
            <TextField
              color="secondary"
              margin="dense"
              id="name"
              label="姓名"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
            />
          </Box>

          <TextField
            color="secondary"
            margin="dense"
            id="password"
            label="密碼"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          <TextField
            color="secondary"
            margin="dense"
            id="confirmPassword"
            label="確認密碼"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={passwordNotMatch} // Here we set the error state of TextField
            helperText={passwordNotMatch ? "密碼不相同" : ""} // Here we set the helper text when there is an error
          />
          {error !== "" ? (
            <Alert icon={false} severity="warning">
              {error}
            </Alert>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            sx={{ color: "#004B97", border: "1px solid #ACD6FF" }}
            onClick={handleRegisterClose}
          >
            取消
          </Button>
          <Box style={{ flexGrow: 2 }}> </Box>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            onClick={handleSendVerificationButtonClick}
            disabled={loading}
          >
            {loading ? "註冊中..." : "註冊"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openVerification} onClose={handleVerificationClose}>
        <DialogTitle sx={{ fontWeight: "bold" }}>驗證</DialogTitle>
        <DialogContent>
          <TextField
            color="secondary"
            disabled
            margin="dense"
            id="phonetext"
            type="text"
            value={phone}
            fullWidth
          />

          <TextField
            color="secondary"
            margin="dense"
            id="verificationCode"
            label="請輸入驗證碼"
            type="number"
            value={verificationCode}
            onChange={(e) => {
              setVerificationCode(e.target.value);
            }}
            fullWidth
          />
          {error !== "" ? (
            <Alert icon={false} severity="warning">
              {error}
            </Alert>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            sx={{ color: "#004B97", border: "1px solid #ACD6FF" }}
            onClick={handleVerificationClose}
          >
            取消
          </Button>
          <Box style={{ flexGrow: 2 }}> </Box>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            onClick={handleRegisterButtonClick}
            disabled={loading}
          >
            {loading ? "驗證中..." : "驗證"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openForgotPassword} onClose={handleForgotPasswordClose}>
        <DialogTitle sx={{ fontWeight: "bold" }}>忘記密碼</DialogTitle>
        <DialogContent>
          <Typography marginBottom={1} color="secondary">
            發送簡訊來重新設定密碼。
          </Typography>
          <TextField
            color="secondary"
            autoFocus
            margin="dense"
            id="phone"
            label="手機號碼"
            type="number"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            error={phoneError} // Here we set the error state of TextField
            helperText={phoneError ? "手機號碼格式錯誤" : ""} // Here we set the helper text when there is an error
            fullWidth
          />

          {error !== "" ? (
            <Alert icon={false} severity="warning">
              {error}
            </Alert>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            sx={{ color: "#004B97", border: "1px solid #ACD6FF" }}
            onClick={handleForgotPasswordClose}
          >
            取消
          </Button>
          <Box style={{ flexGrow: 2 }}> </Box>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            onClick={handleSendResetPasswordClick}
            disabled={loading}
          >
            {loading ? "處理中..." : "送出"}
          </Button>
        </DialogActions>
      </Dialog>
      <ResetPasswordDialog
        open={openResetPassword}
        handleResetPasswordClose={() => {
          setOpenResetPassword(false);
        }}
      ></ResetPasswordDialog>
      <Snackbar
        open={snakeOpen}
        autoHideDuration={5000}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            return;
          }

          setSnakeOpen(false);
        }}
        message={snakeMsg}
      ></Snackbar>
    </div>
  );
};

export default LoginDialogs;
